<script lang="ts">
export default defineComponent({
  name: 'AppScroll',
})

export interface Props {
  preload?: boolean
}
</script>

<script setup lang="ts">
interface IEmits {
  (event: 'infiniteScroll', e: null): void
  (event: 'windowResize', e: null): void
}

const emit = defineEmits<IEmits>()

const { infiniteScrollListener, windowResizeListener } = useGlobalScroll()
const instance = getCurrentInstance()

onMounted(() => {
  if (instance?.subTree) {
    const children = instance?.subTree?.children
    const element = (children as any[]).at(0).el as HTMLElement

    infiniteScrollListener?.(ref(element), () => emit('infiniteScroll', null))
    windowResizeListener?.(() => emit('windowResize', null))
  }
})
</script>

<template>
  <slot />
</template>
